// Legacy Sidebar — kept as a no-op so existing pages that still import it
// don't break. The new PanelLayout (in components/Panel/) renders the real
// sidebar. Once every old page is migrated to PanelLayout, this file can be
// deleted entirely.

const Sidebar = () => null;
export default Sidebar;
